import Axios from 'axios'
import Config from '../config/app.js'
import {Loading, Notification} from 'element-ui';
import {getToken, isLogin, removeToken} from '../utils/dataStorage.js'
import {
    getAuthParams,
    appendAuthQuery,
    isAuthInvalid,
    setAuthInvalid,
    clearAuthParams,
    SIGN_INVALID_CODES,
    SIGN_INVALID_MSG
} from './authParams.js'

import router from '../router/router'

// 开发环境 devApiUrl 为空字符串时，baseURL 为 '/'，改用空字符串走 devServer proxy
let baseURL = Config.apiUrl + '/' + Config.apiPrefix
if (baseURL === '/') baseURL = ''

const service = Axios.create({
    baseURL: baseURL,
    headers: {
        'Accept': '*/*'
    },
    timeout: Config.timeout
})
service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

service.interceptors.request.use(
    config => {

        if (!config.closeLoading) {
            window.loadingInstance = Loading.service({
                fullscreen: true
            });
        }

        if (isLogin()) {
            config.headers['Access-Token'] = getToken();
        }

        // 签名失效阻断：不再发送任何请求
        if (isAuthInvalid()) {
            return Promise.reject({ __authInvalid: true })
        }

        // 防篡改参数统一注入到 URL query（GET/POST 均适用，由各活动页 mounted 写入 sessionStorage）
        const authParams = getAuthParams()
        if (authParams) {
            config.url = appendAuthQuery(config.url, authParams)
        }

        return config
    },
    error => {
        Promise.reject(error)
    }
)


service.interceptors.response.use(
    response => { //Grade

        const res = response;
        if (!response.config.closeLoading) {
            window.loadingInstance.close();
        }

        if (res.status !== 200) {
            Notification({
                title: '数据返回出错',
                message: "请稍后重试",
                type: 'warning'
            });
            return Promise.reject('error')
        }


        // 签名失效/过期统一拦截（必须在 closeInterceptors 分支之前，确保 5 个 closeInterceptors 接口也覆盖）
        if (res.data && SIGN_INVALID_CODES.indexOf(res.data.code) !== -1) {
            Notification({
                title: '提示',
                message: SIGN_INVALID_MSG,
                type: 'warning',
                duration: 0
            });
            setAuthInvalid(true);
            clearAuthParams();
            return Promise.reject({ __signInvalid: true, code: res.data.code });
        }

        if ((response.config).hasOwnProperty('closeInterceptors') && response.config.closeInterceptors) {
            return res.data
        }

        //  支付使用
        if (res.data.stateCode == "00")  return res.data;

        if (res.data.code != 200) {
            Notification({
                title: '提示',
                message: res.data.msg,
                type: 'warning'
            });
            return Promise.reject('error');
        }

        return res.data.data;
    },
    error => {
        // v2 接口的 403 是业务错误（如绑定规则限制：仅女性/注册3天内），非 token 身份验证失效。
        // 直接 reject 将后端错误透传给调用方处理，不触发登录跳转、不误入 then 成功分支。
        const isV2Request = error.config && typeof error.config.url === 'string' && error.config.url.indexOf('/v2/') === 0
        if (isV2Request && error.response && error.response.status === 403) {
            if (!error.config.closeLoading) {
                window.loadingInstance.close()
            }
            return Promise.reject(error)
        }
        // v2 接口的 429 是频率限制（如每日上传次数超限），透传给调用方展示具体原因
        if (isV2Request && error.response && error.response.status === 429) {
            if (!error.config.closeLoading) {
                window.loadingInstance.close()
            }
            return Promise.reject(error)
        }
        // v2 接口的 400/422 是后端主动抛出的业务校验错误（如提现金额不足、参数不合法），
        // 透传给调用方展示后端返回的 detail，不显示默认的"服务器可能出了点问题"
        if (isV2Request && error.response && (error.response.status === 400 || error.response.status === 422)) {
            if (!error.config.closeLoading) {
                window.loadingInstance.close()
            }
            return Promise.reject(error)
        }
        // HTTP 层签名失效（若后端用 HTTP 419/401 而非 body.code，由此分支处理）
        if (error && error.response && SIGN_INVALID_CODES.indexOf(error.response.status) !== -1) {
            Notification({
                title: '提示',
                message: SIGN_INVALID_MSG,
                type: 'warning',
                duration: 0
            });
            setAuthInvalid(true);
            clearAuthParams();
            return Promise.reject({ __signInvalid: true, code: error.response.status });
        }
        if (error == "Error: Request failed with status code 403") {
            Notification({
                title: '请求失败',
                message: "身份验证失效,请重新登录",
                type: 'warning'
            });
            removeToken();
            router.push("/");
        } else {
            setTimeout(() => {
                window.loadingInstance.close();
            }, 300)
            Notification({
                title: "请求未响应",
                message: "服务器可能出了点问题",
                type: 'warning'
            });
            return Promise.reject(error) //千万不能去掉，，，否则请求超时会进入到then方法，导致逻辑错误。
        }
    }
)

export default service
